export class SpecialNote {
    toolName: string;
    notes: string[];

    constructor(toolName: string, notes: string[]) {
        this.toolName = toolName;
        this.notes = notes;
    }
}
